import * as React from "react";
import * as _ from "lodash";
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, ICenterCLCDetailsResponse } from "@nkr/store/index";
import CenterCLCScoresDetails from "./center-cls-details";

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterCLCSDetails: (centerId: number) => Promise<ICenterCLCDetailsResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState { }

class CenterCLCScoresDetailsReport extends React.Component<TProps, IState> {
    render = () => {
        return (
            <>
                <CenterCLCScoresDetails
                    centerId={this.props.centerId}
                    isAdmin={this.props.isAdmin}
                    getCenterCLCSDetails={this.props.getCenterCLCSDetails}
                    showLoading={this.props.showLoading}
                    hideLoading={this.props.hideLoading}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCenterCLCSDetails: (centerId) => {
            return dispatch(ReportActionCreators.getCenterCLCScoresDetails(centerId));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterCLCScoresDetailsReport);